import { render, staticRenderFns } from "./PersonProfileHeaderView.vue?vue&type=template&id=7bba9e0f&scoped=true&"
import script from "./PersonProfileHeaderView.vue?vue&type=script&lang=js&"
export * from "./PersonProfileHeaderView.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileHeaderView.vue?vue&type=style&index=0&id=7bba9e0f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bba9e0f",
  null
  
)

export default component.exports